import { getSubscriptionEventTemplate } from './constants'
import type { SubscriptionEventFieldDef } from './field-catalog'
import { getSubscriptionEventFieldDefs } from './field-catalog'

function labelForKey (defs: SubscriptionEventFieldDef[], key: string): string {
  const def = defs.find((d) => d.key === key)
  return def?.label || key
}

export function getSubscriptionEventSendValidationErrors (
  templateId: string,
  fieldValues: Record<string, string>,
): string[] {
  const template = getSubscriptionEventTemplate(templateId)
  if (!template) {
    return [`Unknown subscription event: ${templateId}`]
  }
  const defs = getSubscriptionEventFieldDefs(templateId)
  const errors: string[] = []
  const missingRequired = defs
    .filter((def) => def.required && !String(fieldValues[def.key] || '').trim())
    .map((def) => def.label)
  if (missingRequired.length > 0) {
    errors.push(`Missing required fields: ${missingRequired.join(', ')}`)
  }
  if (!String(fieldValues.subscriptionTier || '').trim()) {
    const hasTierDef = defs.some((d) => d.key === 'subscriptionTier')
    if (hasTierDef && !missingRequired.includes(labelForKey(defs, 'subscriptionTier'))) {
      errors.push('Missing required fields: Subscription tier')
    }
  }
  return errors
}
